import { SmsSettingsTable } from "features/templates/sms/components/SmsSettingsTable";

export { SmsSettingsTable };

export const SmsSettingsPage = () => {
  return <SmsSettingsTable />;
};
